// src/pages/Manufacturing/ManufacturingEntry.jsx
import React, { useEffect, useState } from "react";
import { Row, Col, Button, Flex, Grid } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import CreateManufacturingForm from "./components/CreateManufacturingForm";
import ManufacturingTable from "./components/ManufacturingTable";
import { createManufacturing, fetchManufacturingNumber, fetchManufacturingRecord } from "./manufacturingThunk";
import { calculateTotals, resetManufacturing } from "./manufacturingSlice";
import Swal from "sweetalert2";
import { selectAuthInfo } from "../../Auth/authSelectors";
import { getAccessType, pathSpliter } from "../../../lib/functions";

const ManufacturingEntry = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  let [access_type, access_type_set] = useState("");

  useEffect(() => {
    const access = getAccessType("production_entry");
    access_type_set(access);
  }, []);

  const authInfo = useSelector(selectAuthInfo);
  const { productionCart, rawCart, footerValues } =
    useSelector((s) => s.manufacturing);

  const mfId = pathSpliter(location.pathname, 2)
    ? pathSpliter(location.pathname, 2)
    : null;


  useEffect(() => {
  if (mfId) {
    dispatch(fetchManufacturingRecord(mfId))
    // .unwrap().then(() => {
    //   dispatch(calculateTotals()); 
    // });
  }
}, [mfId, dispatch]);

useEffect(() => {
  if (!mfId) {
    dispatch(resetManufacturing());
    dispatch(fetchManufacturingNumber());
  }
}, [mfId, dispatch]);


  const checkDuplicateProducts = (items) => {
    const seen = new Set();
    const duplicates = [];

    for (const item of items) {
      if (seen.has(item.product)) {
        duplicates.push(item.product);
      }
      seen.add(item.product);
    }
 
    if (duplicates.length > 0) {

      Swal.fire({
        icon: "warning",
        title: "Duplicate Products Found",
      });
      return true;
    }
  };




  const handleSave = () => {
  const itemCart = [...(rawCart || []), ...(productionCart || [])];
    const narration = footerValues.description || "";

    checkDuplicateProducts(rawCart);
    checkDuplicateProducts(productionCart);
    // 1️⃣ Check if cart is empty
    if (itemCart.length === 0) {
      Swal.fire({
        title: "Item cart is Empty!",
        icon: "warning",
      });
      return false;
    }

    const rawCheck = rawCart.some((item) => item.qty == 0 || item.product == "" || item.rate == 0);
    if (rawCheck) {
      Swal.fire({
        title: "Raw Materials item details missing",
        icon: "warning",
      });
      return false;
    }
    const prodCheck = productionCart.some((item) => item.qty == 0 || item.product == "" || item.rate == 0);
    if (prodCheck) {
      Swal.fire({
        title: "Production item details missing",
        icon: "warning",
      });
      return false;
    }


    // 2️⃣ Check if item has qty > 0
    const hasPositiveQty = itemCart.some((item) => Number(item.qty || item.return_qty || 0) > 0);
    if (!hasPositiveQty) {
      Swal.fire({
        title: "Item must have quantity greater than 0!",
        icon: "warning",
      });
      return false;
    }

    // 3️⃣ Check narration length
    if (narration.length > 100) {
      Swal.fire({
        title: "Description Size Exceeded",
        icon: "warning",
      });
      return false;
    }

    // ✅ Passed all validations, proceed to save
    Swal.fire({
      title: "Saving Manufacturing Journal...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    dispatch(createManufacturing(location))
      .unwrap()
      .then((res) => {
        Swal.close();
        if (!res.error) {
          Swal.fire({
            title: "Manufacturing Journal Created! Do you want to view voucher?",
            icon: "success",
            showCancelButton: true,
            confirmButtonText: "Yes, view voucher",
            cancelButtonText: "No, back",
          }).then((result) => {
            dispatch(fetchManufacturingNumber());
            if (result.isConfirmed) {
              navigate(`/manufacturing-quick-voucher/${res.mf_id || res.pur_r_id}`);
            } else {
              dispatch(resetManufacturing());
              navigate("/manufacturing");
            }
          });
        } else {
          Swal.fire(res.message || "Something went wrong", "", "warning");
        }
      })
      .catch(() => {
        Swal.close();
        Swal.fire("Network ERROR", "", "error");
      });
  };


  return (
    <div style={{ padding: 20 }}>
      { !screens.xs && <Row>
        <Col span={24}>
          <Flex justify="flex-end" gap={16} style={{ marginTop: 10 }}>
            <Button onClick={() => navigate(-1)}>Back</Button>
            <Button
              onClick={() => {
                if (mfId) {
                  // editing → reload same record
                  dispatch(fetchManufacturingRecord(mfId))
                    .then(() => dispatch(calculateTotals()));
                } else {
                  // creating → fresh form
                  dispatch(resetManufacturing());
                  dispatch(fetchManufacturingNumber());
                }
              }}
            >
              Reset
            </Button>
            <Button type="primary" onClick={handleSave}>Save</Button>
          </Flex>
        </Col>
      </Row>}

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <CreateManufacturingForm mfId={mfId} authInfo={authInfo} />
        </Col>
        <Col span={24}>
        <div style={{ width: "100%", maxWidth: "1300px" }}>
          <ManufacturingTable type="raw" mfId={mfId} authInfo={authInfo} />
        </div>
        <div style={{ width: "100%", maxWidth: "1300px" }}>
          <ManufacturingTable type="production" mfId={mfId} authInfo={authInfo} />
        </div>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Flex justify="flex-end" gap={16} style={{ marginBottom: 16 }}>
            <Button onClick={() => navigate(-1)}>Back</Button>
            <Button
              onClick={() => {
                if (mfId) {
                  // editing → reload same record
                  dispatch(fetchManufacturingRecord(mfId))
                    // .then(() => dispatch(calculateTotals()));
                } else {
                  // creating → fresh form
                  dispatch(resetManufacturing());
                  dispatch(fetchManufacturingNumber());
                }
              }}
            >
              Reset
            </Button>
            {access_type == "WRITE" && <>
              <Button type="primary" onClick={handleSave}>Save</Button>
            </>}
          </Flex>
        </Col>
      </Row>
    </div>
  );
};

export default ManufacturingEntry;
